import React from 'react';
import { Col } from 'react-bootstrap';
import BPLogo from '../bp-logo';
import ActionLink from '../action-link';
import HelpResourcesLink from '../help-resources-link';
import VerticalPipe from '../vertical-pipe';
import OrganizationSelector from '../organization-selector';
import Navigation from '../navigation';
import shared from '../../styles/shared.css';
import styles from './styles.css';

const { logOut } = require('../../../lib/bputils').default;

class Header extends React.Component {
  state = {
    hideResourceText: false,
    hideSignOutText: false,
    hideAccountText: false,
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleHeaderResize);
    this.determineIfHiddenText();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleHeaderResize);
  }

  handleSignOutUser = () => {
    logOut();
  }

  handleHeaderResize = () => {
    this.determineIfHiddenText();
  }

  determineIfHiddenText() {
    const windowWidth = window.innerWidth;
    const { hideResourceText, hideSignOutText, hideAccountText } = this.state;
    const shouldHideResourceText = windowWidth < 1200;
    const shouldHideSignOutText = windowWidth < 1000;
    const shoulHideAccountText = windowWidth < 950;
    if ((hideResourceText !== shouldHideResourceText) || (hideSignOutText !== shouldHideSignOutText) || (hideAccountText !== shoulHideAccountText)) {
      this.setState(() => ({
        hideResourceText: shouldHideResourceText,
        hideSignOutText: shouldHideSignOutText,
        hideAccountText: shoulHideAccountText,
      }));
    }
  }

  render() {
    const { hideResourceText, hideSignOutText, hideAccountText } = this.state;
    return (
      <div className={styles.header}>
        <div style={{ width: '100%', display: 'inline-flex' }}>
          <Col xs={4} sm={4} md={4}>
            <BPLogo
              logoUrl="/images/app/business-pages-logo-white.png"
              redirectUrl="/client/home.html"
              height={40}
            />
          </Col>
          <Col xs={5} sm={5} md={4} style={{ textAlign: 'center' }}>
            <OrganizationSelector />
          </Col>
          <Col className={shared.pullRight} xs={3} sm={3} md={4} style={{ textAlign: 'right' }}>
            <ActionLink
              onClickAction={() => { window.location = '/client/users/profile.html'; }}
              imagePath="/images/app/icon_my_acct_default.svg"
              hoverImagePath="/images/app/icon_my_acct_active.svg"
              imageAlign="left"
              linkText="My Account"
              hideText={hideAccountText}
              customClasses={shared.white}
            />
            <VerticalPipe pipeHeight={15} />
            <HelpResourcesLink hideText={hideResourceText} />
            <VerticalPipe height={15} />
            <ActionLink
              onClickAction={this.handleSignOutUser}
              imagePath="/images/app/icon_sign_out_default.svg"
              hoverImagePath="/images/app/icon_sign_out_active.svg"
              imageAlign="right"
              linkText="Sign Out"
              hideText={hideSignOutText}
              customClasses={shared.white}
            />
          </Col>
        </div>
        <div>
          <Navigation />
        </div>
      </div>
    );
  }
}

export default Header;
